import { BaseMetadata, syncBaseMetadata } from '@msdk/definitions'
import { RecoilValueReadOnly, selector, selectorFamily } from 'recoil'

import { $apiClient } from '../core'

export const $baseMetadata: RecoilValueReadOnly<BaseMetadata> = selector({
  key: 'BaseMetadata',
  get: async ({ get }) => {
    const client = get($apiClient)
    const res = await client.metadata.getBaseMetadata()
    syncBaseMetadata(res)
    return res
  },
})

export const $baseMetadataByEntity = selectorFamily({
  key: 'BaseMetadataByEntity',
  get:
    (entityName: string) =>
    ({ get }) => {
      const baseMetadata = get($baseMetadata)
      return baseMetadata.entities.find((e) => e.name === entityName)
    },
})

export const $compilationManifest = selector({
  key: 'CompilationManifest',
  get: async ({ get }) => {
    const client = get($apiClient)
    const res = await client.metadata.getCompilationManifest()
    return res
  },
})
